import { render, staticRenderFns } from "./ManufacturerInput.vue?vue&type=template&id=6c74f27c&scoped=true&"
import script from "./ManufacturerInput.vue?vue&type=script&lang=js&"
export * from "./ManufacturerInput.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerInput.vue?vue&type=style&index=0&id=6c74f27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c74f27c",
  null
  
)

export default component.exports